module.exports = __webpack_public_path__ + "85548007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_feature6.png
// module id = 1757
// module chunks = 0